import { UIChampionship26Controller } from '../../../../../shared/scripts/ui_cc/UIChampionship26Controller.ts';
export class UIDChampionship26SceneController {
    hide() {
        this.championship26SceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.championship26SceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        new UIChampionship26Controller();
        this.championship26SceneContainerDiv = document.getElementById('scene_discord_championship26_container');
    }
}
